// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    'report.page.title.receivables_ageing_report': 'Accounts Receivables Ageing Report',

    'report.page.title.sales_by_customer_report': 'Sales By Customer',
    'report.page.title.sales_by_service_report': 'Sales by Service',
    'report.page.title.sales_by_product_report': 'Sales by Product',

    'report.label.sort.direction_label': 'Sort Order',
    'report.label.sort.field_label': 'Sort By',
    'report.label.year': 'Year',

    'report.label.service_name': 'Service Name',
    'report.label.product_name': 'Product Name',
    'report.label.inventory_name': 'Inventory Name',
    'report.label.month_january': 'January',
    'report.label.month_february': 'February',
    'report.label.month_march': 'March',
    'report.label.month_april': 'April',
    'report.label.month_may': 'May',
    'report.label.month_june': 'June',
    'report.label.month_july': 'July',
    'report.label.month_august': 'August',
    'report.label.month_september': 'September',
    'report.label.month_october': 'October',
    'report.label.month_november': 'November',
    'report.label.month_december': 'December',
    'report.label.total_sales': 'Total Sales',

    'report.message.no_invoices': 'No invoice transactions were found for the period.',
};
